import { createFileRoute } from "@tanstack/react-router";
import PartsAccountAddresses from "@/pages/parts-account/PartsAccountAddresses";

export const Route = createFileRoute("/_partsAuth/parts-catalog/account/addresses")({
  component: PartsAccountAddresses,
});
